import store from '../../init/store.js'
import {getDeadTeams} from '../lifecycle/get-dead-teams.js'
import {getAllCombatantsOfTeam} from '../lifecycle/team-utilities.js'

export function getBattleEndReport() {

  const hpReport = store.getState().battle.hpRatingsOfTeamsPerTurnSeries;
  const turnReporting = store.getState().battle.turnReporting;
  const allCombatants = store.getState().battle.combatants;

  const teamOne = getAllCombatantsOfTeam("one", allCombatants);
  const teamTwo = getAllCombatantsOfTeam("two", allCombatants);

  const deadTeamId = getDeadTeams()[0] === "one" ? "two" : "one"; //winning team is opposite of dead team

  return {
    turnSeriesCount: hpReport.length - 1, //last one is added at the end
    winningTeamId: deadTeamId,
    hpReport: hpReport,
    turnReporting: turnReporting,
    teamOneReport: {
      ...getTeamReport(teamOne),
      //hpReport: hpReport.map(array => array[0]) //team one is the first entry
    },
    teamTwoReport: {
      ...getTeamReport(teamTwo),
      //hpReport: hpReport.map(array => array[1]) //team two is the second entry
    }

  }

}

function getTeamReport(teamCombatants) {
  return {
    classes: teamCombatants.map(comb => {
      return `LVL ${comb.level} ${comb.class}`
    }),
    humanCount: teamCombatants.filter(comb => !comb.isBot).length,
    botCount: teamCombatants.filter(comb => comb.isBot).length,
  }
}


// WEBPACK FOOTER //
// ./src/battle/analysis/get-battle-end-report.js